// extracted by mini-css-extract-plugin
module.exports = {"default":"doctor_default__1N1lz","divided":"doctor_divided__hA6XM","photo":"doctor_photo__tbnt4","name":"doctor_name__XXyKA","practice":"doctor_practice__1gEPJ"};